<template>
    <div id="amrContinersData">
        <a-modal  v-model="visible" @ok="handleOk" width="30%" :maskClosable="false" :closable="false">
           <template slot="footer">
                <a-button type="primary" small="size" @click="handleOk">{{ $t('publicLang.PubOk') }}</a-button>
            </template>
            <a-row>
                <a-col>
                    <a-textarea style="height: 200px;border: none;" v-model="cartonNumbers" readonly="true"></a-textarea>
                </a-col>
            </a-row>
            <a-row>
                <a-col align="center">
                    <p>Total carton(s):</p>
                    <div style="color: black;font-size: 60px;font-weight: bold;">
                         <p>{{ totalCartons }}</p>
                    </div>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    export default{
        data(){
            return{
                visible: false,
                form:  this.$form.createForm(this),
                cartonNumbers: '',
                totalCartons:'',
            /*    formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },*/
            }
        },
        methods:{
            handleOk(){
                this.visible = false
            },
            show(tt){
                this.visible = true
                this.cartonNumbers = tt.message;
                this.totalCartons = tt.totalContainer;
            }
        }
    }
</script>